import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Login from "../pages/Login/";
import Inbox from "../pages/Inbox";
import Updates from "../pages/Updates";
import { InboxProvider } from "../context/Inbox";
import { ReplyNotificationsProvider } from "../context/ReplyNotifications";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Companies from "../pages/Companies/";
import FlydeskDevices from "../pages/FlydeskDevices/";
import TestMode from "../pages/TestMode/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <WhatsAppsProvider>
              <InboxProvider>
              <ReplyNotificationsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/inbox" component={Inbox} isPrivate />
                <Route exact path="/updates" component={Updates} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/test-mode" component={TestMode} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/companies" component={Companies} isPrivate superOnly />
                {/* Sem superOnly: o admin da empresa gerencia os PCs dela;
                    o backend e quem limita o escopo de cada um. */}
                <Route exact path="/flydesk/devices" component={FlydeskDevices} isPrivate />
              </LoggedInLayout>
              </ReplyNotificationsProvider>
              </InboxProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
